import { OBSTACLE_SUBTYPE, OBSTACLE_TYPE } from "./../ENUM.js";
import * as SOUND_DATA from "./../SOUND_DATA.js";

export const MAUVE = {
  isDark: true,
  startHealth: 10,
  timeAllowedSecs: 40,
  textColor: "#ffffff",
  textColorHighlight: "#fcb7eb",
  bgColor: "#500083",
  bgFadeAlpha: 0.5,
  gameplayAreaToCanvasLateralRatio: 0.8,
  player: {
    color: "#ffffff",
    growthDivisor: 2000,
    radius: 15,
  },
  obstacles: [
    {
      type: OBSTACLE_TYPE.BACKGROUND,
      total: 400,
      color_ar: ["#fcb7eb", "#ffccf2"],
      radiusRange: [1, 2],
      directionRange: [175, 185],
      speedRange: [0.001, 0.004],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      collectSfx_ar: SOUND_DATA.ORDERED_CLACK_SFX_AR,
      total: 20,
      color_ar: ["#0000ff", "#0000dd", "#0000bb", "#000099"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 20,
      color_ar: ["#0000ff", "#0000dd", "#0000bb", "#000099"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [3, 3],
      rotationSpeedRange: [0.1, 0.3],
      shapeCenterRadiusDivisor: 6,
      shapeCenterColor_ar: ["#ffffff", "#dcc8ff", "#a3e0ff"],
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 20,
      color_ar: ["#0000ff", "#0000dd", "#0000bb", "#000099"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [6, 6],
      rotationSpeedRange: [0.1, 0.3],
      shapeCenterRadiusDivisor: 6,
      shapeCenterColor_ar: ["#ffffff", "#dcc8ff", "#a3e0ff"],
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.COLLECT,
      subtype: OBSTACLE_SUBTYPE.FLOWER,
      collectSfx_ar: SOUND_DATA.ORDERED_POP_SFX_AR,
      total: 20,
      color_ar: ["#0000ff", "#0000dd", "#0000bb", "#000099"],
      radiusRange: [50, 50],
      directionRange: [120, 240],
      speedRange: [1, 3],
      numAppendagesRange: [9, 9],
      rotationSpeedRange: [0.1, 0.3],
      shapeCenterRadiusDivisor: 6,
      shapeCenterColor_ar: ["#ffffff", "#dcc8ff", "#a3e0ff"],
      useDefaultStroke: true,
    },
    {
      type: OBSTACLE_TYPE.AVOID,
      total: 6,
      color_ar: ["#fffa00"],
      radiusRange: [30, 55],
      directionRange: [120, 240],
      speedRange: [2, 3],
    },
  ],
};
